import React, {createContext, ReactNode, useContext} from 'react';
import {IPopperProps, placements} from 'react-popper';

interface MenuContextValue {
  isOpen: boolean;
  toggle: () => void;
  close: () => void;
  closeOnItemClick: boolean;
  position: (typeof placements)[number];
  positionFixed: boolean;
  popperProps?: Partial<IPopperProps>;
}

const MenuContext = createContext<MenuContextValue | null>(null);

export const useMenu = () => {
  const context = useContext(MenuContext);
  if (!context) {
    throw new Error('useMenu must be used within a Menu component');
  }
  return context;
};

export const useMenuSafe = () => {
  return useContext(MenuContext);
};

interface MenuProviderProps {
  children: ReactNode;
  value: MenuContextValue;
}

export const MenuProvider = ({children, value}: MenuProviderProps) => (
  <MenuContext.Provider value={value}>{children}</MenuContext.Provider>
);
